export enum AnswerButtonTypeEnum
{
    NewQuestion = 1,
    Counseling = 2,
}